import {camelizeKeys} from 'humps';
import {types} from 'mobx-state-tree';
import defaultAvatar from '../../../../images/default-avatar.jpg';
import MessageFormat, {MessageFormatType} from '../format';

// tslint:disable-next-line:no-any
function normalizeBtns(btns: any[]) {
  return btns && btns.length > 0
    ? btns.map(({type, ...rest}) => ({kind: type, ...rest}))
    : null;
}

// tslint:disable-next-line:no-any
function normalizeMessageFormat(message: any) {
  if (!message) {
    return {text: ''};
  }
  const {attachment, ...restMessage} = message;

  if (!attachment) {
    return message;
  }
  const {type: attachmentType, ...restAttachment} = attachment;

  if (attachmentType !== 'template') {
    return {
      attachment: {
        kind: attachmentType,
        ...restAttachment
      },
      ...restMessage
    };
  }

  const {payload} = restAttachment;

  const {templateType, buttons, elements, ...restPayload} = payload;

  return {
    attachment: {
      kind: attachmentType,
      payload:
        attachmentType === 'template'
          ? {
              templateKind: templateType,
              ...(templateType === 'button'
                ? {buttons: normalizeBtns(buttons)}
                : {
                    // tslint:disable-next-line:no-any
                    elements:
                      elements &&
                      elements.map(
                        // tslint:disable
                        ({buttons: btns, ...rest}: any) => ({
                          buttons: normalizeBtns(btns),
                          ...rest
                        })
                      )
                  }),
              ...restPayload
            }
          : payload
    }
  };
}

export type NormalizedMessageViews = {
  // tslint:disable-next-line:no-any
  normalizedData: any;
  format: MessageFormatType;
  senderId: number;
  senderName: string;
  senderAvatar: string;
};

const NormalizedMessageModel = types
  .model({
    data: types.string
  })
  .views<NormalizedMessageViews>(self => {
    // tslint:disable-next-line:no-any
    const computed = (self as any) as NormalizedMessageViews;

    return {
      get normalizedData() {
        return camelizeKeys(JSON.parse(self.data));
      },
      get format() {
        return MessageFormat.create(
          normalizeMessageFormat(computed.normalizedData.message)
        );
      },
      get senderId() {
        return computed.normalizedData.sender.id;
      },
      get senderName() {
        const {firstName, lastName} = computed.normalizedData.sender;
        return lastName ? `${firstName} ${lastName}` : firstName;
      },
      get senderAvatar() {
        return computed.normalizedData.sender.avatar || defaultAvatar;
      }
    };
  });

export type NormalizedMessage = typeof NormalizedMessageModel.Type;

export default NormalizedMessageModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/shared/normalizedMessageModel.ts